<template>
  <div
      class="credenciamentoPendenteMes"
      v-loading="isLoading"
      style="padding: 10px; background: #fff; border-radius: 8px;"
  >
    <h3 style="text-align: center; margin-bottom: 1rem">Credenciamentos pendentes no Mês</h3>
    <div class="mb-20" style="display: flex; justify-content: center">
      <apexchart
          height="300"
          width="400"
          type="bar"
          :options="chartOptionsAccreditationPending"
          :series="seriesBarAccreditationPending"
      ></apexchart>
    </div>
  </div>
</template>

<script>
  import {getAccreditationPending} from "../../../services";
  import { makeErrorFilds } from "@/app/plugins/utils";

  export default {
    name: 'CredenciamentoPendente',

    data() {
      return {
        isLoading: false,
        boxAtualStyle: {
          background: "var(--primary-color)",
          color: "var(--secondary-color)",
        },

        chartOptionsAccreditationPending: {
          style: {
            colors: ["#304758"],
          },
          tooltip: {
            enabled: true,
          },
          chart: {
            id: "credenciamento-pendente-chart-bar",
            type: "bar",
          },
          labels: [
            "Analise de Risco",
            "Erro Dados Bancários",
            "Adquirente",
            "Associação de Planos",
            "Erro Gateway"
          ],
          plotOptions: {
            bar: {
              borderRadius: 10,
              dataLabels: {
                position: 'center', // top, center, bottom
              },
            }
          },
          dataLabels: {
            enabled: true,
            offsetY: -20,
            style: {
              fontSize: "12px",
            },
          },
        },
        seriesBarAccreditationPending: [],
      }
    },

    methods: {
      async fetchAccreditationPending() {
        this.isLoading = true;

        try {
          let response = await getAccreditationPending();
          let chartList = [
            { x: 'Analise de Risco', y: response.data.risk_analysis },
            { x: 'Erro Conta Bancária', y: response.data.bank_account_error },
            { x: 'Adquirente', y: response.data.acquirer },
            { x: 'Associação de Planos', y: response.data.pending_plan },
            { x: 'Erro Gateway', y: response.data.gateway_error },
          ]

          this.seriesBarAccreditationPending.push({
            name: "Credenciamentos Pendentes",
            data: chartList,
          });
        } catch (e) {
          this.$message({
            showClose: true,
            message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
            type: "error",
          });
        } finally {
          this.isLoading = false;
        }
      }
    },

    async beforeMount() {
      await this.fetchAccreditationPending();
    }
  }
</script>

<style scoped>

</style>